import PropTypes from 'prop-types'
import { TimeSlotContainer, TimeIconWrapper, TimeText } from './styled'
import Clock from '../../assets/svgs/clock'
import theme from '../../constants/theme'
import { BookedBadge } from './styled'
import { useTranslation } from 'react-i18next'

function TimeSlot({ startTime, isAvailable, isBooked, onClick }) {
  const { t } = useTranslation()
  return (
    <TimeSlotContainer isAvailable={isAvailable} onClick={onClick}>
      <TimeIconWrapper>
        <Clock
          width={16}
          height={16}
          color={isAvailable ? theme.brandColorOrange : theme.gray}
        />
        <TimeText>{startTime}</TimeText>
      </TimeIconWrapper>
      {isBooked && <BookedBadge>{t('calendar.booked')}</BookedBadge>}
    </TimeSlotContainer>
  )
}

TimeSlot.propTypes = {
  startTime: PropTypes.string.isRequired,
  isAvailable: PropTypes.bool.isRequired,
  isBooked: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default TimeSlot
